module.exports = "<md-toolbar ng-if=vm.errorKey class=error-bar><div flex layout=row layout-align=\"start center\" class=\"md-warn msg-container\"><div translate={{vm.errorKey}} translate-values={{vm.errorValues}} class=error-msg></div><div translate={{vm.errorDetails}} translate-values={{vm.errorDetailsValues}} class=error-details></div></div></md-toolbar>";


//////////////////
// WEBPACK FOOTER
// ../~/@printos/gazelle/src/components/error-bar/error-bar.jade
// module id = 228
// module chunks = 0